const contactData = {
  email: {
    label: 'Email',
    value: 'kendall@kendallwhitman.photography',
  },
  phone: {
    label: 'Call or Text',
    value: '2148387695',
    valueFormatted: '214-838-7695'
  },
}

export default contactData
